const createEditable = require('./createEditable');
const createVariation = require('../../utils/createVariation');

const Slider = require('../../components/slider');

module.exports = {
  Original: createEditable(createVariation(Slider, 'original')),
  Material: createEditable(createVariation(Slider, 'material')),
};
